export const updateChangeRequest = (obj) => ({
    type: "UPDATE_CHANGE_REQUEST",
    obj,
});

export const updateChangeRequestSuccess = (data) => ({
    type: "UPDATE_CHANGE_REQUEST_SUCCESS",
    data,
});

export const updateChangeRequestFail = (error) => ({
    type: "UPDATE_CHANGE_REQUEST_FAIL",
    error,
});